import { useEffect, useState } from 'react'
import { Input, Checkbox, Divider } from 'antd'
import { useCreateMacroData } from '../CreateMacroDataProvider'
import { setFieldData } from '../CreateMacroDataProvider/actions'
import FormLikeField from './FormLikeField'

SwitchLabelConfig = ({ fieldKey }) ->

  [{ fieldData }, dispatch] = useCreateMacroData()

  setConfig = (key, value) -> ({ target }) ->
    dispatch(
      setFieldData(
        _.set(
          fieldData,
          [fieldKey, 'save', key],
          { label: target.value, value }
        )
      )
    )

  <>
    <FormLikeField label="Affirmative label">
      <Input
        value={fieldData[fieldKey]?.save?.onKey?.label}
        placeholder="Yes"
        onChange={setConfig('onKey', true)}
      />
    </FormLikeField>
    <FormLikeField label="Negative label">
      <Input
        value={fieldData[fieldKey]?.save?.offKey?.label}
        placeholder="No"
        onChange={setConfig('offKey', false)}
      />
    </FormLikeField>
    <Divider />
  </>

export default SwitchLabelConfig